import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';
import { Page } from '../../components/layout/page';
import { ContentContainer } from '../../components/layout/containers/ContentContainer';
import { ApplicationButton } from '../../components/application/ApplicationButton';
import AuthContext from '../../auth/AuthContext';
import { styles } from './styles.js';

const PortalError = ({ classes }) => {
  const msalInstance = useContext(AuthContext);
  const { t } = useTranslation();

  const handleLogout = () => {
    msalInstance.logoutRedirect({
      account: msalInstance.getActiveAccount(),
      postLogoutRedirectUri: window.location.href,
    });
  };

  const buttonProps = {
    label: t('errorPageButton.label'),
    props: {
      'data-testid': `logout`,
      onClick: handleLogout,
    },
  };

  return (
    <>
      <Helmet>
        <title>
          {t('meta.title')}
          {t('errorPage.title')}
        </title>
      </Helmet>
      <Page resolving={false}>
        <ContentContainer>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card className={classes.card} elevation={0}>
                <CardContent className={classes.content}>
                  <Typography
                    variant="h7"
                    component="h1"
                    gutterBottom
                    className={classes.title}
                  >
                    {t('errorPageContent.title')}
                  </Typography>
                  <Typography variant="body2">
                    {t('errorPageContent.description')}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <ApplicationButton
                buttonProps={{
                  ...buttonProps.props,
                }}
                classes={{ root: classes.errorBtn }}
                label={buttonProps.label}
                showIcon
              />
            </Grid>
          </Grid>
        </ContentContainer>
      </Page>
    </>
  );
};

export default withStyles(styles)(PortalError);
